export const normalizeRoleName = (role = "") =>
  String(role || "").trim().toLowerCase();

export const getRolePermissions = (user, rolesOrPermissions = []) => {
  if (!user) return {};

  if (
    rolesOrPermissions &&
    !Array.isArray(rolesOrPermissions) &&
    typeof rolesOrPermissions === "object"
  ) {
    return rolesOrPermissions;
  }

  const roles = Array.isArray(rolesOrPermissions) ? rolesOrPermissions : [];
  const userRole = normalizeRoleName(user.role);

  const roleDoc = roles.find(
    (r) => normalizeRoleName(r.roleName) === userRole
  );

  return roleDoc?.permissions || {};
};

export const can = (user, rolesOrPermissions = [], moduleKey, action = "view") => {
  if (!user) return false;

  if (normalizeRoleName(user.role) === "admin") return true;

  const permissions = getRolePermissions(user, rolesOrPermissions);

  return Boolean(permissions?.[moduleKey]?.[action]);
};